import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { api, gameShowWsUrl } from "../lib/api";
import { GameShowScoreboard } from "../components/game/GameShowScoreboard";
import { Trophy, X } from "lucide-react";

export default function GameShowScoreboardPopoutPage() {
  const { showId } = useParams();
  const [show, setShow] = useState(null);
  const [characters, setCharacters] = useState([]);
  const socketRef = useRef(null);

  const loadShow = async () => {
    const { data } = await api.get(`/game-shows/${showId}`);
    setShow(data);
    if (data.my_role === "host") {
      const params = data.game_id ? { params: { game_id: data.game_id } } : {};
      api.get("/characters", params).then((r) => setCharacters(r.data)).catch(() => setCharacters([]));
    }
  };

  useEffect(() => { loadShow(); }, [showId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let socket;
    (async () => {
      const { data } = await api.get("/auth/ws-token");
      socket = new WebSocket(gameShowWsUrl(showId, data.token));
      socketRef.current = socket;
      socket.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data);
          if (msg.type === "gameshow_state") setShow((prev) => ({ ...msg.data, my_role: prev?.my_role, my_participant_id: prev?.my_participant_id }));
        } catch {}
      };
    })();
    return () => socket?.close();
  }, [showId]);

  if (!show) return <div className="min-h-screen bg-[#151613] flex items-center justify-center text-[#f1e0c5]/50 text-sm uppercase tracking-widest">Loading…</div>;

  return (
    <div className="min-h-screen bg-[#151613] text-[#f1e0c5] p-4" data-testid="gameshow-scoreboard-popout-page">
      <div className="flex items-center justify-between mb-3">
        <p className="font-display text-sm text-[#f1e0c5]/60 flex items-center gap-1.5 truncate"><Trophy className="w-3.5 h-3.5 text-[#D4AF37]" /> {show.name}</p>
        <button data-testid="gameshow-scoreboard-popout-close" onClick={() => window.close()} className="text-[#f1e0c5]/40 hover:text-[#D90429]">
          <X className="w-4 h-4" />
        </button>
      </div>
      <GameShowScoreboard show={show} isHost={show.my_role === "host"} characters={characters} onChanged={() => {}} />
    </div>
  );
}
